import { useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { useAuthStore } from "@/features/auth/model/store.ts"
import { SidebarItem } from "@/features/sidebar/ui/sidebar-item.tsx"
import { SidebarItems } from "@/features/sidebar/ui/sidebar-items.tsx"
import dashboardRoutes from "@/pages/dashboard/routes.tsx"
import { useAllowedRoutes } from "@/shared/hooks/use-allowed-routes.ts"
import { isDevelopment } from "@/shared/config/environment"

interface IProps {
  allOpen?: boolean
}

const SidebarMain = ({ allOpen }: IProps) => {
  // Helpers
  const location = useLocation()
  const navigate = useNavigate()
  const { me } = useAuthStore()

  // Store
  const permittedRoutes = useAllowedRoutes(dashboardRoutes)

  // State
  const [open, setOpen] = useState<string | null>(null)

  // Effects
  const path = location.pathname.split("/")[2]

  useEffect(() => {
    setOpen(path)
  }, [])

  // Functions
  if (!me) return null

  return (
    <div className="sidebar__links -m-2 p-2 pr-0">
      <div className="sidebar__links__box gap-px pr-1.5">
        {permittedRoutes?.map((config, index) => (
          <div key={index}>
            {config.children != null && config.handle?.ignoreChildren !== true ? (
              <SidebarItems
                open={config.path === open}
                onOpen={() => setOpen(old => (old === config.path ? null : (config.path ?? "")))}
                items={config.children}
                item={config}
                path={config.path}
                allOpen={allOpen}
              />
            ) : (
              <SidebarItem item={config} withChild={config.children != null} onClick={() => {}} path={config.path} />
            )}
          </div>
        ))}
      </div>
      {isDevelopment && (
        <div>
          <SidebarItem className="mt-auto" item={{ path: "/dashboard/ui-kit", handle: { label: "Выйти", icon: "ChartRing", i18Key: "UI Kit" } }} />
          <SidebarItem className="mt-auto" item={{ path: "/dashboard/icons", handle: { label: "Выйти", icon: "ChartRing", i18Key: "Icons" } }} />
        </div>
      )}
    </div>
  )
}

export default SidebarMain
